import axios from 'axios';
import { handleRequests } from '@redux-requests/core';
import { createDriver as createAxiosDriver } from '@redux-requests/axios';
import { createDriver as createGraphqlDriver } from '@redux-requests/graphql';
import { onError, onRequest } from './authInterceptors';
import appConfig from 'constants/appConfig';

export const { requestsReducer, requestsMiddleware } = handleRequests({
  driver: {
    default: createGraphqlDriver({ url: appConfig.gqlUrl }),
    axios: createAxiosDriver(axios),
  },
  onRequest,
  onError,
});
